import * as React from "react";
const SvgFiRrEmptySet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-empty-set_svg__a)">
      <path
        fill="#062147"
        d="M23.707.293a1 1 0 0 0-1.414 0l-3.259 3.26A10.94 10.94 0 0 0 12 1C5.935 1 1 5.935 1 12c0 2.673.961 5.125 2.552 7.034l-3.259 3.26a.999.999 0 1 0 1.414 1.413l3.26-3.259A10.94 10.94 0 0 0 12 23c6.065 0 11-4.935 11-11 0-2.673-.96-5.125-2.552-7.034l3.26-3.259a1 1 0 0 0 0-1.414M3 12c0-4.962 4.038-9 9-9 2.122 0 4.071.742 5.611 1.975L4.975 17.611A8.95 8.95 0 0 1 3 12.001m18 0c0 4.963-4.038 9-9 9a8.95 8.95 0 0 1-5.61-1.975L19.024 6.39A8.95 8.95 0 0 1 21 12"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-empty-set_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEmptySet;
